import { createReducer } from '@reduxjs/toolkit';

import patchUserRole from '../../thunks/users/patchUserRole';

const initialState = {
  loading: false,
  updated: false,
  error: null,
};

const patchUserRoleReducer = createReducer(initialState, {
  [patchUserRole.pending]: (state) => ({
    ...state,
    loading: true,
    updated: false,
    error: null
  }),
  [patchUserRole.fulfilled]: (state) => ({
    ...state,
    loading: false,
    updated: true,
  }),
  [patchUserRole.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    updated: false,
    error: payload,
  }),
});

export default patchUserRoleReducer;
